import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { Location } from '@angular/common'


@Component({
  selector: 'app-send-promo',
  templateUrl: './send-promo.component.html',
  styleUrls: ['./send-promo.component.scss']
})
export class SendPromoComponent extends FeaturesBaseComponent implements OnInit {
  @Input() countries: [];
  @Input() productTypes: [];
  promoForm: FormGroup;
  constructor(private location: Location) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initForm()
  }
  initForm() {
    this.promoForm = new FormGroup({
      carrier: new FormControl(),
      product: new FormControl(),
      amount: new FormControl(),
      productDescription: new FormControl(),
      validity: new FormControl(),
      country: new FormControl(),
      textMessage: new FormControl()
    })
  }

  get f() {
    return this.promoForm.controls;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onCancel() {
    this.promoForm.reset();
    this.location.back()

  }
}
